import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemImage2GsIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.38 10.35L16.5 6.35C16.27 6.21 15.98 6.21 15.75 6.35L13.76 7.51V2C13.76 1.59 13.42 1.25 13.01 1.25H1C0.59 1.25 0.25 1.59 0.25 2V11.6C0.25 12.01 0.59 12.35 1 12.35H8.49V19C8.49 19.27 8.63 19.51 8.86 19.65L15.74 23.65C15.97 23.79 16.26 23.79 16.49 23.65L23.37 19.65C23.6 19.52 23.74 19.27 23.74 19V11C23.74 10.73 23.6 10.49 23.37 10.35H23.38ZM1.75 2.75H12.25V7.16L9.8 5.12C9.57 4.93 9.23 4.93 9 5.12L6.28 7.39L5 6.32C4.77 6.13 4.43 6.13 4.2 6.32L1.75 8.36V2.75ZM8.53 10.85H1.75V9.99L4.6 7.62L5.88 8.69C6.11 8.88 6.45 8.88 6.68 8.69L9.4 6.42L11.96 8.56L8.86 10.36C8.68 10.47 8.57 10.65 8.53 10.86V10.85ZM15.5 21.77L10 18.57V12.18L15.5 15.36V21.77ZM22.25 18.57L16.75 21.77V15C16.75 14.78 16.63 14.57 16.44 14.46L10.6 11.09L16.13 7.87L22.26 11.43V18.57H22.25Z"
        fill={color}
      />
      <path
        d="M17 2.75H21C21.14 2.75 21.25 2.86 21.25 3V7C21.25 7.41 21.59 7.75 22 7.75C22.41 7.75 22.75 7.41 22.75 7V3C22.75 2.04 21.96 1.25 21 1.25H17C16.59 1.25 16.25 1.59 16.25 2C16.25 2.41 16.59 2.75 17 2.75Z"
        fill={color}
      />
      <path
        d="M7 21.25H3C2.86 21.25 2.75 21.14 2.75 21V17C2.75 16.59 2.41 16.25 2 16.25C1.59 16.25 1.25 16.59 1.25 17V21C1.25 21.96 2.04 22.75 3 22.75H7C7.41 22.75 7.75 22.41 7.75 22C7.75 21.59 7.41 21.25 7 21.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemImage2GsIcon.displayName = 'ItemImage2GsIcon';
